import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const EventListPage = () =>
  import('@modules/event/components/event-list-page.vue');
const EventFormPage = () =>
  import('@modules/event/components/event-form-page.vue');
const EventViewPage = () =>
  import('@modules/event/components/event-view-page.vue');
const EventImporterPage = () =>
  import('@modules/event/components/event-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'event',
        path: '/event',
        component: EventListPage,
        meta: {
          auth: true,
          permission: Permissions.values.eventView,
        },
      },
      {
        name: 'eventNew',
        path: '/event/new',
        component: EventFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.eventCreate,
        },
      },
      {
        name: 'eventImporter',
        path: '/event/import',
        component: EventImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.eventImport,
        },
      },
      {
        name: 'eventEdit',
        path: '/event/:id/edit',
        component: EventFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.eventEdit,
        },
        props: true,
      },
      {
        name: 'eventView',
        path: '/event/:id',
        component: EventViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.eventView,
        },
        props: true,
      },
    ],
  },
];
